import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { ECSalesSearchHeader } from "./header";
import { BasicSearchSection } from "./section/basic-search-actions";
import { Filter } from "./section/filter";
import { SearchResultTable } from "./table";
import { useInitialized } from "../../model/use-case";

type Props = {
	hotelID: string;
};

export const ManagementECSalesSearch = ({ hotelID }: Props) => {
	/**
	 * 初期化
	 */
	const {
		//
		searchType,
		onSetSearchType,

		freeTextSearch,
		onSetFreeTextSearch,

		viewData,

		//
		onSearchSalesMastList,
	} = useInitialized({ hotelID });

	return (
		<FeatureIslandContainer>
			<ECSalesSearchHeader />

			<FeatureIslandMainWithBackGround>
				<div>
					<div className="space-y-5">
						{/* 通常検索セクション */}
						<BasicSearchSection
							onSearchSalesMastList={onSearchSalesMastList}
							searchType={searchType}
							onSetSearchType={onSetSearchType}
						/>
						<Filter freeTextSearch={freeTextSearch} onSetFreeTextSearch={onSetFreeTextSearch} />
					</div>

					{/* 検索結果テーブル */}
					<div className="mt-10">
						<SearchResultTable viewData={viewData} />
					</div>
				</div>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

ManagementECSalesSearch.displayName = "ManagementECSalesSearch";
